<template>
  <div>
    <div>
      <el-button :type="currentType === 'styleTheme' ? 'primary' : '' " @click="currentType = 'styleTheme'">风格主题</el-button>
      <el-button :type="currentType === 'festivalTheme' ? 'primary' : '' " @click="currentType = 'festivalTheme'">节日主题</el-button>
    </div>
    <div class="content">
      <ul class="content_ul">
        <li v-for="item in currentType === 'styleTheme' ? styleTheme : festivalTheme " :key="item.id" class="ul_li" @click="$emit('determine', {type:currentType, item})">
          <img class="li_img" :src="item.img">
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
import { /* readingservice, */ acawraccountlist } from '@/api/sourceMaterial.js'
export default {
  props: {
    platformid: {
      type: Number,
      default: null
    }
  },
  data() {
    return {
      styleTheme: [],
      festivalTheme: [],
      currentType: 'styleTheme'
    }
  },
  created() {
    this.getTypeData()
  },
  methods: {
    async getTypeData() {
      const data = await acawraccountlist({
        platformId: this.platformid,
        activityType: 1 })
      data.data.theme.forEach((item) => {
        if (item.style === 'activity') {
          this.styleTheme.push(item)
        } else {
          this.festivalTheme.push(item)
        }
      })
    }
  }
}
</script>

<style scoped>
li{
  list-style-type:none;
}

.content{

}

.content_ul{
    display: flex;
    flex-wrap: wrap;
}

.ul_li{
  padding: 10px;
  cursor: pointer;
}

.ul_li:hover{
  background-color: #abcdef;
}

.li_img{
    width: 200px;
    height: 200px;
}
</style>
